Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var formDiscardAction = function (element, definition) {

        Vendd.inlineEdit.action.apply(this, [element, definition]);

    };
    formDiscardAction.prototype = Object.create(Vendd.inlineEdit.action.prototype);
    formDiscardAction.prototype.name = 'formDiscardAction';

    formDiscardAction.prototype.Enabled = function () {

        var self = this;

        var form = self.getForm();

        return form !== undefined
            && typeof form.hasChanges === 'function'
            && form.hasChanges();
    }

    formDiscardAction.prototype.execute = function () {

        var self = this;

        if (!self.Enabled()) {

            return;

        }

        var form = self.getForm();

        if (form === undefined) {

            return;

        }

        form.discard();

    };

    Vendd.inlineEdit.formDiscardAction = formDiscardAction;

});